"use client"

import { EqualNot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `EqualNotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const EqualNotIcon = component(Icon)({ as: EqualNot })
